import React, { useMemo } from "react";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import { OptimizationParameterParameterType, } from "store/rs-workspace/rs-workspace.types";
import { isNotEmpty } from "utils/validate";
import { N_A } from "shared/rsDictionary";
import * as styles from "./styles.module.scss";
const ParameterValueAppearance = ({ parameter, usedVariantStepFlows, stepId }) => {
    const valueAppearance = useMemo(() => {
        switch (parameter?.type) {
            case OptimizationParameterParameterType.CELL_MODEL_OR_RECIPE: {
                const { units, value } = { ...parameter };
                if (!isNotEmpty(value, true)) {
                    return N_A;
                }
                return `${parameter?.value} ${units}`;
            }
            case OptimizationParameterParameterType.ALTERNATIVE_FLOW: {
                const usedVariantFlowId = usedVariantStepFlows?.find((config) => config.stepId === stepId)?.flowId;
                return (usedVariantFlowId ?? 0) === 0
                    ? "Default flow"
                    : parameter.flows?.find(({ id }) => id === usedVariantFlowId)?.name;
            }
            default:
                return "";
        }
    }, [parameter, stepId, usedVariantStepFlows]);
    return (React.createElement(TextTruncate, { className: classNames(styles["parameter-value"], styles["parameter-value-viewMode"]), text: valueAppearance }));
};
export default ParameterValueAppearance;
